// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
  --button-width: 2.5em;
  --button-height: 1.5em;
  --toggle-diameter: 1.1em;
  --button-toggle-offset: calc(
    (var(--button-height) - var(--toggle-diameter)) / 2
  );
  --toggle-shadow-offset: 10px;
  --toggle-wider: 3em;
  --color-grey: #cccccc;
  --color-green: #D22F31;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.switch .slider {
  display: inline-block;
  width: var(--button-width);
  height: var(--button-height);
  background-color: var(--color-grey);
  border-radius: calc(var(--button-height) / 2);
  position: relative;
  transition: 0.3s all ease-in-out;
  cursor: pointer;
}
.switch .slider::after {
  content: "";
  display: inline-block;
  width: var(--toggle-diameter);
  height: var(--toggle-diameter);
  background-color: #fff;
  border-radius: calc(var(--toggle-diameter) / 2);
  position: absolute;
  top: var(--button-toggle-offset);
  transform: translateX(var(--button-toggle-offset));
  box-shadow: var(--toggle-shadow-offset) 0 calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);
  transition: 0.3s all ease-in-out;
}
.switch input[type=checkbox] {
  display: none;
}
.switch input[type=checkbox]:checked + .slider {
  background-color: var(--color-green);
}
.switch input[type=checkbox]:checked + .slider::after {
  transform: translateX(calc(var(--button-width) - var(--toggle-diameter) - var(--button-toggle-offset)));
  box-shadow: calc(var(--toggle-shadow-offset) * -1) 0 calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);
}
.switch input[type=checkbox]:active + .slider::after {
  width: var(--toggle-wider);
}
.switch input[type=checkbox]:checked:active + .slider::after {
  transform: translateX(calc(var(--button-width) - var(--toggle-wider) - var(--button-toggle-offset)));
}`, "",{"version":3,"sources":["webpack://./src/components/base/Switch/Switch.styles.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA;;GAAA;EAGA,4BAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACF;AACE;EACE,qBAAA;EACA,0BAAA;EACA,4BAAA;EACA,mCAAA;EACA,6CAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AACJ;AACI;EACE,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;EACA,+CAAA;EACA,kBAAA;EACA,gCAAA;EACA,kDAAA;EACA,kGAAA;EAEA,gCAAA;AAAN;AAIE;EACE,aAAA;AAFJ;AAII;EACE,oCAAA;AAFN;AAIM;EACE,uGAAA;EAMA,6GAAA;AAPR;AAYI;EACE,0BAAA;AAVN;AAaI;EACE,oGAAA;AAXN","sourcesContent":[".switch {\n  --button-width: 2.5em;\n  --button-height: 1.5em;\n  --toggle-diameter: 1.1em;\n  --button-toggle-offset: calc(\n    (var(--button-height) - var(--toggle-diameter)) / 2\n  );\n  --toggle-shadow-offset: 10px;\n  --toggle-wider: 3em;\n  --color-grey: #cccccc;\n  --color-green: #D22F31;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n\n  .slider {\n    display: inline-block;\n    width: var(--button-width);\n    height: var(--button-height);\n    background-color: var(--color-grey);\n    border-radius: calc(var(--button-height) / 2);\n    position: relative;\n    transition: 0.3s all ease-in-out;\n    cursor: pointer;\n\n    &::after {\n      content: '';\n      display: inline-block;\n      width: var(--toggle-diameter);\n      height: var(--toggle-diameter);\n      background-color: #fff;\n      border-radius: calc(var(--toggle-diameter) / 2);\n      position: absolute;\n      top: var(--button-toggle-offset);\n      transform: translateX(var(--button-toggle-offset));\n      box-shadow: var(--toggle-shadow-offset) 0\n        calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);\n      transition: 0.3s all ease-in-out;\n    }\n  }\n\n  input[type='checkbox'] {\n    display: none;\n\n    &:checked + .slider {\n      background-color: var(--color-green);\n\n      &::after {\n        transform: translateX(\n          calc(\n            var(--button-width) - var(--toggle-diameter) -\n              var(--button-toggle-offset)\n          )\n        );\n        box-shadow: calc(var(--toggle-shadow-offset) * -1) 0\n          calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    &:active + .slider::after {\n      width: var(--toggle-wider);\n    }\n\n    &:checked:active + .slider::after {\n      transform: translateX(\n        calc(\n          var(--button-width) - var(--toggle-wider) -\n            var(--button-toggle-offset)\n        )\n      );\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
